export const T = {
  en_GB: { by: "Quantfolio Platform by", terms: "Terms of Service", privacy: "Privacy Policy" },
  nb_NO: {
    by: "Quantfolio Platform fra",
    terms: "Vilkår for bruk",
    privacy: "Personvernerklæring",
  },
} as const;
